import { api } from '../../lib/api';
import type { DriveFolderListing } from '../../components/drive/types';

// GET /api/drive/folder/:folderId/files
//
// Returns the listing wire shape (server/lib/driveClient.ts → DriveFile,
// shaped through src/components/drive/types.ts → DriveFileSummary). When
// `refresh=true`, the server bypasses the cache and re-fetches.
export async function listDriveFolder(
  folderId: string,
  options: { refresh?: boolean } = {},
): Promise<DriveFolderListing> {
  const qs = options.refresh ? '?refresh=true' : '';
  return api<DriveFolderListing>(`/api/drive/folder/${encodeURIComponent(folderId)}/files${qs}`);
}
